<template>
    <div class="register-account">
        <div class="register-account__heading">
            <div class="register-account__eyebrow">CREATE ACCOUNT</div>
            <div class="register-account__title">注册账号</div>
            <div class="register-account__subtitle">手机号或邮箱注册后，可同时用于趣拍星与趣拍精灵</div>
        </div>

        <el-form class="register-account__form" :model="formData" @submit.native.prevent>
            <el-form-item>
                <el-input v-model="formData.account" prefix-icon="el-icon-user-solid" placeholder="请输入手机号或邮箱" autocomplete="username"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="formData.code" prefix-icon="el-icon-message" maxlength="8" placeholder="请输入验证码" autocomplete="one-time-code">
                    <el-button slot="append" :loading="sendingCode" :disabled="seconds > 0" @click="sendCode">{{ codeText }}</el-button>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="formData.password" prefix-icon="el-icon-lock" type="password" maxlength="64" placeholder="请设置至少 6 位密码" autocomplete="new-password" show-password></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="formData.password_confirmation" prefix-icon="el-icon-circle-check" type="password" maxlength="64" placeholder="请再次输入密码" autocomplete="new-password" show-password @keyup.enter.native="submit"></el-input>
            </el-form-item>

            <label class="register-account__agreement">
                <input v-model="agreed" type="checkbox">
                <span>我已阅读并同意
                    <a href="https://v2.interestar.net/index/protocol/user_agreement" target="_blank" @click.stop>《用户协议》</a>
                    和
                    <a href="https://v2.interestar.net/index/protocol/user_privacy" target="_blank" @click.stop>《隐私政策》</a>
                </span>
            </label>

            <div class="register-account__actions">
                <el-button class="register-account__back" plain :disabled="submitting" @click="$emit('back')">返回登录</el-button>
                <el-button class="register-account__submit" type="primary" :loading="submitting" @click="submit">注册并登录</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { requestAccountRegister, requestAccountRegisterCode } from '@/api/app';

    export default {
        name: 'register-account-form',
        props: {
            account: {
                type: String,
                default: ''
            }
        },
        data(){
            return {
                sendingCode: false,
                submitting: false,
                seconds: 0,
                timer: null,
                codeAccount: '',
                agreed: false,
                formData: {
                    account: this.account || '',
                    code: '',
                    password: '',
                    password_confirmation: ''
                }
            }
        },
        computed: {
            codeText(){
                if(this.sendingCode) return '发送中';
                return this.seconds > 0 ? this.seconds + 's' : '获取验证码';
            }
        },
        watch: {
            'formData.account'(value){
                if(!this.codeAccount || String(value || '').trim() === this.codeAccount) return;
                this.clearTimer();
                this.seconds = 0;
                this.codeAccount = '';
                this.formData.code = '';
            }
        },
        beforeDestroy(){
            this.clearTimer();
        },
        methods: {
            normalizeAccount(){
                return String(this.formData.account || '').trim();
            },
            clearTimer(){
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            startTimer(){
                this.clearTimer();
                this.seconds = 60;
                this.timer = setInterval(() => {
                    this.seconds--;
                    if(this.seconds <= 0){
                        this.seconds = 0;
                        this.clearTimer();
                    }
                }, 1000);
            },
            sendCode(){
                if(this.sendingCode || this.seconds > 0) return;
                const account = this.normalizeAccount();
                if(!account) return this.$utils.showMsg('请输入手机号或邮箱', 'error');
                this.formData.account = account;
                this.sendingCode = true;
                requestAccountRegisterCode({ account }).then(res => {
                    this.sendingCode = false;
                    if(this.normalizeAccount() !== account) return;
                    this.codeAccount = account;
                    this.$utils.showMsg(res.message || '验证码发送成功');
                    this.startTimer();
                }).catch(() => {
                    this.sendingCode = false;
                });
            },
            submit(){
                if(this.submitting) return;
                const account = this.normalizeAccount();
                if(!account) return this.$utils.showMsg('请输入手机号或邮箱', 'error');
                if(!this.formData.code || this.codeAccount !== account) return this.$utils.showMsg('请先获取并输入当前账号的验证码', 'error');
                if(String(this.formData.password || '').length < 6) return this.$utils.showMsg('密码不能少于6位', 'error');
                if(this.formData.password !== this.formData.password_confirmation) return this.$utils.showMsg('两次密码输入不一致', 'error');
                if(!this.agreed) return this.$utils.showMsg('请先阅读并同意用户协议和隐私政策', 'error');

                this.formData.account = account;
                this.submitting = true;
                requestAccountRegister(this.formData).then(res => {
                    this.submitting = false;
                    this.$utils.showMsg(res.message || '注册成功');
                    this.$emit('success', res.data, account);
                }).catch(() => {
                    this.submitting = false;
                });
            }
        }
    }
</script>

<style lang="scss">
    .register-account {
        width: 360px;
        margin: -14px auto 0;
        color: #26354a;
    }
    .register-account__heading { text-align: left; }
    .register-account__eyebrow { color: #409eff; font-size: 12px; font-weight: 700; letter-spacing: 2px; }
    .register-account__title { margin-top: 6px; font-size: 28px; font-weight: 700; }
    .register-account__subtitle { margin-top: 8px; color: #7a8798; font-size: 13px; line-height: 1.6; }
    .register-account__form { margin-top: 20px; }
    .register-account__agreement {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin: -2px 2px 18px;
        color: #77869a;
        font-size: 12px;
        line-height: 1.6;
        cursor: pointer;
        input { margin-top: 3px; }
        a { color: #409eff; text-decoration: none; }
    }
    .register-account__actions { display: flex; gap: 12px; }
    .register-account__back, .register-account__submit { flex: 1; }
    .black_mode .register-account {
        color: #eef5ff;
        .register-account__subtitle,
        .register-account__agreement { color: rgba(229, 239, 252, 0.62); }
        .register-account__form .el-input__inner {
            border-color: rgba(255, 255, 255, 0.12);
            background: rgba(255, 255, 255, 0.07);
            color: #f4f8ff;
        }
    }
</style>
